<div class="o-flex--full">
  <form class="o-flex o-flex--column u-margin-bottom-m" [formGroup]="form">
    <mat-form-field class="o-flex--full" appearance="outline">
      <mat-label>Company Name</mat-label>
      <input matInput formControlName="organization_name" />
    </mat-form-field>
    <div class="o-flex o-flex--gap-1">
      <mat-form-field class="o-flex--wider" appearance="outline">
        <mat-label>Billing country</mat-label>
        <mat-select formControlName="billing_country" required>
          <mat-option *ngFor="let country of countries" [value]="country.id">
            {{country.name}}
          </mat-option>
        </mat-select>
        <mat-error *ngIf="form.get('billing_country')?.hasError('required')">
          Please specify your billing country
        </mat-error>
      </mat-form-field>
      <mat-form-field class="o-flex--full" appearance="outline">
        <mat-label>VAT number</mat-label>
        <input matInput formControlName="vat_number" />
      </mat-form-field>
    </div>
    <h2>Billing Period</h2>
    <mat-radio-group formControlName="billing_period" class="subscription-radio-group">
      <mat-radio-button [value]=1 class="subscription-radio-button">Annual</mat-radio-button>
      <mat-radio-button [value]=2 class="subscription-radio-button">Quarterly</mat-radio-button>
      <mat-radio-button [value]=3 class="subscription-radio-button">Monthly</mat-radio-button>
    </mat-radio-group>
    <div *ngIf="showLactate && showPPD">
      <h2>Test types</h2>
      <div class="subscription-test-types">
        <mat-checkbox formControlName="use_lactate" class="subscription-test-type">Lactate</mat-checkbox>
        <mat-checkbox formControlName="use_ppd" class="subscription-test-type">PPD</mat-checkbox>
      </div>
    </div>
    <div *ngIf="sportFeatures()">
      <h2>Sports</h2>
      <app-chips
        [label]="'Sports'"
        [form]="form.get('sports')"
        [options]="sportOptions"
        [displayField]="'name'"
        (optionChange)="onSelectSport($event)"
      ></app-chips>
    </div>
  </form>
</div>
